import { ContractResponse } from "../contracts/ContractResponse";
import { Contract } from "../models/Contract";

export const mapResponseToContract = (resp: ContractResponse): Contract => ({
  id: resp.id,
  memberId: resp.memberId,
  type: resp.type,
  status: resp.status,
  defaultPaymentTypeId: resp.defaultPaymentTypeId,
  validFrom: resp.validFrom,
  validUntil: resp.validUntil,
  packSize: resp.packSize,
  monthlyFeeAmountMinorUnits: resp.monthlyFeeAmountMinorUnits,
  monthlyFeeCurrency: resp.monthlyFeeCurrency,
  cadence: resp.cadence,
  notes: resp.notes,
  acceptanceStatus: resp.acceptanceStatus,
  acceptanceRequestedAt: resp.acceptanceRequestedAt,
  acceptedAt: resp.acceptedAt,
  acceptedByGuardian: resp.acceptedByGuardian,
  dateCreated: resp.dateCreated,
  dateModified: resp.dateModified,
});
